
    import '/builds/1N4HJJhF/0/wepie-ee/fe/fe-base/power-design/site/docs/power-design/form-list-table.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-power-design-form-list-table-demo-form-list-table","docs-power-design-form-list-table-demo-disable-rows","docs-power-design-form-list-table-demo-min-rows"],
  getter: () => import(/* webpackChunkName: "meta__docs" */'/builds/1N4HJJhF/0/wepie-ee/fe/fe-base/power-design/site/docs/power-design/form-list-table.md?type=demo')
};